import { ApiService }           from '../../../app-lite/api/api.service';
import { CompanyMessagesModel } from '../../../app-lite/companies/models/company.messages';
import { CustomerPaymentModel } from '../../../app-lite/customer-payments/models/customer-payment';
import { TillpaymentsService }  from '../../../app-lite/tillpayments/tillpayments.service';

import CustomerPaymentHtml from '../../../app-lite/customer-payments/customer-payment.html';

export function CustomerPaymentStates (
  $stateProvider: ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller: 'customerPaymentCtrl',
    name      : 'app.customer-payment',
    params    : {
      customer_id: { squash: true, value: null },
      id         : { squash: true, value: null }
    },
    reloadOnSearch: false,
    templateUrl   : CustomerPaymentHtml,
    url           : '/:customer_id/customer_payment/:id?invoice_id',
    resolve       : {
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      integrations   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      pos_terminals  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/pos_terminals'),
      customer       : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.customer_id
          ? workshopAPI.get('/customer', $stateParams.customer_id)
          : '',
      lostTerminalTransaction: ( $rootScope : any, payment : CustomerPaymentModel, tillpaymentsApi : TillpaymentsService ) => {
        return $rootScope.Company.hasIntegration('tillpayments-pos')
          ? tillpaymentsApi.doesLostTerminalPaymentExist(payment)
          : false;
      },
      payment: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string =>
        $stateParams.id
          ? workshopAPI.get('/customer_payment', $stateParams.id)
          : ''
    }
  });
}
